export const educationList  = [
    {
      title: "Self-Development and Skill Enhancement",
      range: "2019 – 2021",
      desc: "Focused on self-improvement by enhancing technical skills in web development, video editing, and graphic design. Deepened knowledge in JavaScript frameworks like React.js, advanced video editing techniques with tools like DaVinci Resolve and After Effects, and explored 3D modeling and animation using Blender. Engaged in continuous learning through online courses, tutorials, and practical projects to expand my professional competencies.",
    },
    {
      title: "Lviv Polytechnic National University",
      range: "2018 - 2019",
      desc: "Master of Telecommunications and Radio Engineering",
    },
    {
      title: "Software Testing Courses, SkillUp",
      range: "2015",
      desc: "Software Testing Certification",
    },
    {
      title: "Lviv Polytechnic National University",
      range: "2014 - 2018",
      desc: "Bachelor of Radio Engineering",
    },
  ];